<template>
  <div>
    <b-table
      responsive
      :items="items"
      :fields="fields"
    >
      <!-- A custom formatted price column -->
      <template #cell(price)="data">
        <display-currency :value="data.value" />
      </template>
      <!-- A custom formatted discount column -->
      <template #cell(discount)="data">
        {{ data.value | numberFormat }} {{ data.value > 100 ? $t('Currency') : '%' }}
      </template>
      <!-- A custom formatted created_at column -->
      <template #cell(created_at)="data">
        <display-date-time :value="data.value" />
      </template>
      <!-- A custom formatted action column -->
      <template #cell(action)="data">
        <b-button
          v-if="$can('update', 'products')"
          variant="flat-success"
          size="sm"
          class="btn-icon rounded-circle"
          @click="editButtonClicked(data.item)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-button>
        <b-button
          v-if="$can('delete', 'products')"
          variant="flat-danger"
          size="sm"
          class="btn-icon rounded-circle"
          @click="deleteButtonClicked(data.item)"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </template>
    </b-table>
    <div
      v-if="!items.length"
      class="d-flex justify-content-center align-items-center"
    >
      <h6 class="font-weight-bolder mb-0">
        {{ $t("There are no products to display") }}
      </h6>
    </div>
    <products-edit-modal
      :form="editForm"
      :additional-data="additionalData"
      @onHideModal="resetEditForm"
    />
  </div>
</template>

<script>
import { ListTable } from '../../../../common/mixins/list'
import ProductsEditModal from '../edit/ProductsEditModal'

export default {
  name: 'ProductsList',
  components: { ProductsEditModal },
  mixins: [ListTable],
  data() {
    return {
      routeName: 'products',
    }
  },
}
</script>

<style scoped>

</style>
